import React from 'react'

export const noGN3 = [
  {
    Header: 'uuid',
    accessor: "uuid",
    filterable: true,
    filterMethod: (filter, row) =>
      row.uuid.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: 'Planta',
    accessor: "station",
    filterable: true,
    filterMethod: (filter, row) =>
      row.station.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: 'Permiso',
    accessor: "permission",
    filterable: true,
    filterMethod: (filter, row) =>
      row.permission.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: 'RFC Empresa',
    accessor: "rfcLegalEntity",
    filterable: true,
    filterMethod: (filter, row) =>
      row.rfcLegalEntity.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: 'Cliente',
    accessor: "customer",
    filterable: true,
    filterMethod: (filter, row) =>
      row.customer.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: 'RFC Cliente',
    accessor: "rfcCustomer",
    filterable: true,
    filterMethod: (filter, row) =>
      row.rfcCustomer.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: 'Precio',
    accessor: "price",
    filterable: true,
    filterMethod: (filter, row) =>
      row.price.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: 'Fecha',
    accessor: "date",
    filterable: true,
    filterMethod: (filter, row) =>
      row.date.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: 'Cantidad',
    accessor: "quantity",
    filterable: true,
    filterMethod: (filter, row) =>
      row.quantity.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: 'Medida',
    accessor: "measurementUnit",
    filterable: true,
    filterMethod: (filter, row) =>
      row.measurementUnit.toLowerCase().includes(filter.value.toLowerCase()),
  },
]

export const SAT = [
  {
    Header:  () => (<span style={{ fontSize: '.7rem' }}>uuid</span>),
    accessor: "uuid",
    filterable: true,
    filterMethod: (filter, row) =>
      row.uuid.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header:  () => (<span style={{ fontSize: '.7rem' }}>Emisor</span>),
    accessor: "issuer",
    filterable: true,
    filterMethod: (filter, row) =>
      row.issuer.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header:  () => (<span style={{ fontSize: '.7rem' }}>RFC Emisor</span>),
    accessor: "rfcIssuer",
    filterable: true,
    filterMethod: (filter, row) =>
      row.rfcIssuer.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header:  () => (<span style={{ fontSize: '.7rem' }}>Cliente</span>),
    accessor: "customer",
    filterable: true,
    filterMethod: (filter, row) =>
      row.customer.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header:  () => (<span style={{ fontSize: '.7rem' }}>RFC Cliente</span>),
    accessor: "rfcCustomer",
    filterable: true,
    filterMethod: (filter, row) =>
      row.rfcCustomer.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header:  () => (<span style={{ fontSize: '.7rem' }}>RFC Pac</span>),
    accessor: "rfcPac",
    filterable: true,
    filterMethod: (filter, row) =>
      row.rfcPac.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header:  () => (<span style={{ fontSize: '.7rem' }}>Factura</span>),
    accessor: "invoiceDate",
    filterable: true,
    filterMethod: (filter, row) =>
      row.invoiceDate.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header:  () => (<span style={{ fontSize: '.7rem' }}>Certificación</span>),
    accessor: "certificationDate",
    filterable: true,
    filterMethod: (filter, row) =>
      row.certificationDate.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header:  () => (<span style={{ fontSize: '.7rem' }}>Cantidad</span>),
    accessor: "amount",
    filterable: true,
    filterMethod: (filter, row) =>
      row.amount.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header:  () => (<span style={{ fontSize: '.7rem' }}>Movimiento</span>),
    accessor: "movementType",
    filterable: true,
    filterMethod: (filter, row) =>
      row.movementType.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header:  () => (<span style={{ fontSize: '.7rem' }}>Estatus</span>),
    accessor: "status",
    filterable: true,
    filterMethod: (filter, row) =>
      row.status.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header:  () => (<span style={{ fontSize: '.7rem' }}>Cancelacion</span>),
    accessor: "cancellationDate",
    filterable: true,
    filterMethod: (filter, row) =>
      row.cancellationDate.toLowerCase().includes(filter.value.toLowerCase()),
  },
]